<div class="scheduler-dialog-container">
  <!-- Header con titolo e pulsante chiudi -->
  <div class="scheduler-dialog-header">
    <h2 mat-dialog-title>Calendario Eventi</h2>
    <button mat-icon-button (click)="close()" aria-label="Chiudi">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Contenuto: Calendario completo -->
  <mat-dialog-content>
    <ct-model [configuration]="configuration"></ct-model>
    <app-scheduler-legend></app-scheduler-legend>
  </mat-dialog-content>
</div>
